export default "__VITE_ASSET__BluOo26h__"